import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
    title = 'Pick Lanka Tours - Explore Sri Lanka',
    description = 'Experience the beauty of Sri Lanka with Pick Lanka Tours. We offer customized tour packages, cultural experiences, safaris, and beach holidays across the island.',
    keywords = 'Pick Lanka Tours, Sri Lanka Tours, Travel Sri Lanka, Tour Packages, Adventure Tours, Cultural Tours, Sri Lanka Vacations, Sri Lanka Holidays, Safari Sri Lanka, Beach Tours, Nature Tours, Sri Lanka Travel Agency, Private Tours, Pick Lanka Travel',
    image = '%PUBLIC_URL%/logo.png',
    url = 'https://picklanka.com',
}) => {
    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : 'https://picklanka.com';
    const resolvedUrl =
        typeof url === 'string' && url.startsWith('https://picklanka.com')
            ? url.replace('https://picklanka.com', currentOrigin)
            : url;

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Pick Lanka Tours" />

            {/* Open Graph (for Facebook, WhatsApp, etc.) */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={resolvedUrl} />
            <meta property="og:type" content="website" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
        </Helmet>
    );
};

export default SEO;